import React from 'react';
import { useTranslation } from 'react-i18next';
import type { LayerGroup } from '../types/layer';
import Legend from './Legend';
import './LegendPanel.css';

interface LegendPanelProps {
  layerGroups: LayerGroup[];
  onEditLegend: (layer: any) => void;
  onOpacityChange: (layerId: string, opacity: number) => void;

}

const LegendPanel: React.FC<LegendPanelProps> = ({
  layerGroups,
  onEditLegend,
  onOpacityChange
}) => {
  const { t } = useTranslation();

  // 모든 그룹에서 보이는 레이어들을 하나의 배열로 합치기
  const allVisibleLayers = layerGroups.flatMap(group => 
    group.layers.filter(layer => layer.visible)
  );

  return (
    <div className="legend-panel">
      <div className="panel-content">
        <h3>{t('legend.title')}</h3>
        
        {/* 모든 보이는 레이어를 하나의 Legend 컴포넌트에서 표시 */}
        {allVisibleLayers.length > 0 ? (
          <Legend
            visible={true}
            layers={allVisibleLayers}
            onEditLegend={onEditLegend}
            onOpacityChange={onOpacityChange}
    
          />
        ) : (
          <div className="no-visible-layers">
            <p>{t('legend.noVisibleLayers')}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LegendPanel; 